import { RequestItem } from './request-item';

export class Condition 
{
    id: number|undefined;
    code:String;
    label:String;
    checked:Boolean;
    isDeleted:Boolean;
    createBy:String;
    createAt:String;
    updateBy:String;
    updateAt:String;
    requestItem:RequestItem;
}